
export default function Demerits() {
  const demerits = [
    {
      title: 'デポジット（保証金）が必要',
      description: 'カード利用前にデポジット（5万円〜200万円）を預ける必要があります。このデポジットは脱会時に返金されますが、初期費用として準備が必要です。',
    },
    {
      title: '年会費・発行手数料がかかる',
      description: '年会費1,375円（税込）と発行手数料1,100円（税込）がかかります。年会費無料のカードと比較するとコストがかかる点はデメリットです。',
    },
    {
      title: 'キャッシング機能がない',
      description: 'このカードはショッピング専用カードのため、キャッシング機能はありません。現金が必要な場合は別の方法を検討する必要があります。',
    },
    {
      title: '旅行保険が付帯していない',
      description: '海外旅行傷害保険や国内旅行傷害保険は付帯していません。旅行時の保険が必要な場合は、別途保険に加入する必要があります。',
    },
  ];

  return (
    <section className="py-16 bg-[#FFF8F0]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          デポジット型クレジットカードのデメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">申込前に知っておきたい注意点</p>

        <div className="grid md:grid-cols-2 gap-6">
          {demerits.map((demerit, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md p-6 border-l-4 border-[#FF9900]">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#FFF0E0] rounded-full flex-shrink-0">
                  <i className="ri-alert-line text-[#FF9900]"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#003366] mb-2">{demerit.title}</h3>
                  <p className="text-gray-700 text-sm leading-relaxed">{demerit.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white rounded-xl shadow-md p-6">
          <h3 className="font-bold text-[#003366] mb-4 text-center">デメリットを踏まえた上でおすすめの方</h3>
          <div className="flex flex-wrap justify-center gap-3">
            <span className="bg-[#E3F2FD] text-[#003366] text-sm px-4 py-2 rounded-full">審査が不安な方</span>
            <span className="bg-[#E3F2FD] text-[#003366] text-sm px-4 py-2 rounded-full">フリーランス・個人事業主</span>
            <span className="bg-[#E3F2FD] text-[#003366] text-sm px-4 py-2 rounded-full">利用限度額を自分で決めたい方</span>
            <span className="bg-[#E3F2FD] text-[#003366] text-sm px-4 py-2 rounded-full">借金するのが嫌いな方</span>
            <span className="bg-[#E3F2FD] text-[#003366] text-sm px-4 py-2 rounded-full">キャッシング案内が不要な方</span>
          </div>
        </div>
      </div>
    </section>
  );
}
